<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{'Graphics'|translate}}
                </v-card-title>
                <v-card-actions>
                    <span style="width:300px;"><v-text-field  class="ml-2" clearable v-model="search" type="text" :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-spacer></v-spacer>
                    <v-btn class="accent mr-2" @click="editedItem=null;readOnly=false;dialog=true" :disabled="!$can('update', 'Graphic')"><v-icon small class="mr-2">fa-plus</v-icon> {{'Add'|translate}}</v-btn>
                    <graphic-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()" :read-only="readOnly"></graphic-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="graphics"
                    class="elevation-1"
                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    :items-per-page="25"
                    :search="search2"
            >
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.type }}</td>
        <td>{{ props.item.floor }}</td>
        <td>
          <v-icon
            small
            class="mr-2"
            @click="viewItem(props.item)"
          >
            fa-eye
          </v-icon>
            <v-icon
            small
            class="mr-2"
            v-if="$can('update', 'Graphic')"
            @click="$can('update', 'Graphic') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            v-if="$can('update', 'Graphic')"
            @click="$can('update', 'Graphic') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">{{'Reset'|translate}}</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getGraphic, deleteGraphic} from '../helper'
import GraphicDialog from "../components/GraphicDialog";

export default {
    name: 'Graphic',
  components: { GraphicDialog },
  data(){
        return{  
      dialog: false,
      readOnly: false,
      headers: [
        { text: this.$options.filters.translate('Name'), value: 'name' },
        { text: this.$options.filters.translate('Type'), value: 'type'},
        { text: this.$options.filters.translate('Floor'), value: 'floor'},
        { text: this.$options.filters.translate('Actions'), sortable: false },
      ],
      graphics: [],
      editedItem: {
      },
      search: '',
      search2: ''
    }},

  mounted() {
    this.initialize()
  },
  watch: {
    search(){
      this.debounce(this.syncSearches,500);
    }
  },
    methods: {
      initialize () {
        this.refresh()
      },

        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.readOnly = false
            this.dialog = true
        },
        viewItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.readOnly = true
            this.dialog = true
        },
      async deleteItem (item) {
        if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?')) ){
          await deleteGraphic({
            'graphic_id': item.graphic_id
          })
          this.refresh()
        }
      },

      async refresh() {
        let df = await getGraphic({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.graphics = df['result']
      },
      syncSearches(){
        this.search2=this.search
      },
      debounce(callback, wait) {
        clearTimeout(this.timeout);
        this.timeout= setTimeout(() => callback(), wait);
      },
    }
  }
</script>

<style scoped>

</style>
